/**
 * Instagram feed, ported from src/components/InstagramFeed.tsx.
 *
 * Fetches the snapshot the instagram-sync edge function writes to Supabase
 * Storage and renders the first four posts. Parsing is defensive and never
 * throws, matching normalizeFeed() in src/lib/instagram.ts — a bad payload
 * leaves the skeletons in place rather than blanking the section.
 */
(function () {
  const root = document.querySelector('[data-cs-instagram]');
  if (!root || !root.dataset.feed) return;

  const isStr = (v) => typeof v === 'string' && v.length > 0;

  const normalize = (raw) => {
    if (!raw || typeof raw !== 'object' || !Array.isArray(raw.posts)) return [];
    return raw.posts
      .filter((p) => p && isStr(p.permalink) && isStr(p.imageUrl))
      .map((p) => ({
        permalink: p.permalink,
        imageUrl: p.imageUrl,
        caption: isStr(p.caption) ? p.caption : '',
      }));
  };

  const fail = () => {
    root.innerHTML =
      '<div class="col-span-2 md:col-span-4 border border-background/20 p-8 text-sm text-background/60">' +
      "Couldn't load the Instagram feed right now.</div>";
  };

  fetch(root.dataset.feed, { cache: 'no-cache' })
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
    .then((data) => {
      const posts = normalize(data).slice(0, 4);
      if (!posts.length) return fail();
      root.innerHTML = posts
        .map(
          (p) =>
            `<a href="${p.permalink}" target="_blank" rel="noreferrer"` +
            ' class="group relative block aspect-square overflow-hidden rounded-2xl bg-background/10">' +
            `<img src="${p.imageUrl}" alt="${p.caption.slice(0, 120).replace(/"/g, '&quot;')}"` +
            ' loading="lazy" class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105">' +
            '</a>'
        )
        .join('');
    })
    .catch(fail);
})();
